/**
 * className presets that turn the (marketing-sized) shadcn <Button> into calm
 * admin buttons. Use with size="sm":  <Button size="sm" className={adminButton.outline}>
 * tailwind-merge resolves the conflicting height/border/colour utilities.
 */
export const adminButton = {
  primary:
    'h-9 gap-1.5 rounded-lg px-3.5 text-[13px] font-semibold shadow-sm hover:shadow [&_svg]:size-4',
  outline:
    'h-9 gap-1.5 rounded-lg border border-border bg-card px-3 text-[13px] font-medium text-foreground shadow-[var(--adm-shadow-xs)] hover:bg-muted hover:text-foreground [&_svg]:size-4',
  ghost:
    'h-9 gap-1.5 rounded-lg px-3 text-[13px] font-medium text-muted-foreground hover:bg-muted hover:text-foreground [&_svg]:size-4',
  soft:
    'h-9 gap-1.5 rounded-lg bg-secondary px-3 text-[13px] font-semibold text-secondary-foreground hover:bg-secondary/80 [&_svg]:size-4',
  icon:
    'h-8 w-8 rounded-lg border border-border bg-card p-0 text-foreground shadow-[var(--adm-shadow-xs)] hover:bg-muted hover:text-foreground [&_svg]:size-4',
  /** Borderless square icon button for table-row actions (pair with variant="ghost" size="sm"). */
  iconGhost:
    'h-8 w-8 rounded-lg p-0 text-muted-foreground hover:bg-muted hover:text-foreground [&_svg]:size-4',
  /** Quiet destructive action: outline that turns red on hover. */
  danger:
    'h-9 gap-1.5 rounded-lg border border-border bg-card px-3 text-[13px] font-medium text-destructive shadow-[var(--adm-shadow-xs)] hover:border-destructive/30 hover:bg-destructive/[0.06] hover:text-destructive [&_svg]:size-4',
} as const;

/** Segmented-control presets for shadcn <TabsList>/<TabsTrigger> (matches the Schedule view switch). */
export const adminTabs = {
  list: 'h-9 w-auto justify-start gap-0.5 rounded-[10px] border border-border bg-muted p-[3px] text-muted-foreground',
  trigger:
    'h-[28px] gap-1.5 rounded-[7px] px-3 text-[13px] font-medium data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:shadow-[var(--adm-shadow-sm)] [&_svg]:h-4 [&_svg]:w-4',
} as const;

/** Compact field sizing for <Input>/<SelectTrigger> outside an .adm-form container. */
export const adminInput = 'h-9 rounded-[9px] bg-card text-[13.5px] shadow-[var(--adm-shadow-xs)]';

/** Small text-link style used in panel headers ("View all →"). */
export const adminLink =
  'inline-flex items-center gap-1 rounded-md px-1.5 py-1 text-[12.5px] font-semibold text-primary hover:bg-secondary';
